<template>
  <div class="terminal" v-if="myQuestions">
    <div class="terminalHeader">
      <p id="windowName">{{ msg }}</p>
      <div class="windowButton">
        <window-buttons></window-buttons>
      </div>
    </div>
    <div id="terminalFrame">
      <div v-show="visible" class="quiz">
        <p class="user">{{ commandHead }} ./quiz</p>
        <quiz-question :screenHeight="screenHeight" :screenWidth="screenWidth" :setNumber="setNumber" :myQuestions="myQuestions"></quiz-question>
        <quiz-options :setNumber="setNumber" :myQuestions="myQuestions" @get-message="transferMessageToInputField"></quiz-options>
        <!--div class="inputBlock">
          <p class="user">quizteilnehmer@gonicus:~$ </p>
          <input
            v-model="message"
            ref="textField"
            @keyup.enter="log"
            type="text"
            id="inputAnswer"
          />
          <input class="mobileButton" type="button" v-if="screenWidth<600" @click="log(this.message)" value="Enter">
        </div-->
        <quiz-answer :commandHead="commandHead" :screenWidth="screenWidth" :message="message" @enterAnswer="transferMessageToInputField" @log="log" ref="quizAnswerRef"></quiz-answer>
      </div>
      <div v-if="result==true" class="results">
        <quiz-result-bar
          ref="quizResultBar"
          :commandHead=commandHead
          :teamMatchPercentage="answerBilance"
          :answerBilance="answerBilance"
          @set-invitation.once="changeInvitation"
        ></quiz-result-bar>
      </div>
      <div v-if="invitation==true">
        <continue-dialog @continue="contactFormQuery" @focus="focusInput" :screenWidth="screenWidth"></continue-dialog>
      </div>
      <div v-show="startForm">
        <contact-form @filledOutForm="changeToGoodBye"></contact-form>
      </div>
      <div v-if="startGoodbye">
        <good-bye-dialog :commandHead=commandHead></good-bye-dialog>
      </div>                               
    </div>
  </div>
</template>

<script>
import QuizQuestion from "./QuizQuestion.vue";
import QuizResultBar from "./QuizResultBar.vue";
import WindowButtons from "./WindowButtons.vue";
import QuizOptions from "./QuizOptions.vue";
import QuizAnswer from "./QuizAnswer.vue";
import ContactForm from "./ContactForm.vue";
import ContinueDialog from "./ContinueDialog.vue";
import GoodByeDialog from "./GoodByeDialog.vue";
//import { nextTick } from 'vue';

export default {
  name: "QuizTerminal",
  components: {
    QuizQuestion,
    QuizResultBar,
    WindowButtons,
    QuizOptions,
    QuizAnswer,
    ContactForm,
    ContinueDialog,
    GoodByeDialog,
  },
  props: {
    msg: String,
    commandHead: String,
   // questionSet: null,
  },
  data() {
    return {
      screenHeight: 0,
      screenWidth: 0,
      myQuestions: null,
      questions: String,
      setNumber: 0,
      active: true,
      trueAnswerCounter: 0,
      message: '',
      textField: null,
      answer: [],
      userAnswer: [],
      myModel: "Initial value",
      visible: true,
      result: false,
      invitation: Boolean,
      startForm: false,
      startGoodbye: false,
      answerBilance: "",
    };
  },
  mounted() {
    this.updateScreenHeight();
    this.onScreenResize();
    this.fetchData();
    this.getCurrentURL();
  },
  updated() {
    this.focusInput();
    this.updateDisplay();
  },
  methods: {
    updateScreenHeight() {
      this.screenHeight = window.innerHeight;
      this.screenWidth = window.innerWidth;
    },
    onScreenResize() {
      window.addEventListener("resize", () => {
        this.updateScreenHeight();
      });
    },
    async fetchData() {
      let link = this.getCurrentURL();
      const response = await fetch(link);
      this.myQuestions = await response.json();
    },
    getCurrentURL () {
      let link = window.location.href;
      let linkPart = link.split("#");
      let linkEnd = linkPart.slice(-1);
      let set = linkEnd[0]+".json";
      return set;
    },
    updateDisplay() {
      this.$refs.quizAnswerRef.$refs.textField.value = this.message;  // Updates displayed value immediately
    },
    transferMessageToInputField(el){
      this.message = el;
      this.$refs.quizAnswerRef.$refs.textField.value = el;
      this.focusInput();
    },
    changeInvitation(el){
      this.invitation = el;
    },
    printQuestion() {
      let setNumber = this.setNumber;
      let answerOptions = this.myQuestions.questions[setNumber].question;
      return answerOptions;
    },
    switch_ques(val) {
      let ques = this.myQuestions;
      let questionsreal = ques.questions;
      let quesLength = questionsreal.length;
      let quesEndIndex = quesLength - 1;
      //this.clearInput();
      if (this.setNumber != quesEndIndex) {
        if (val > 0 || this.setNumber > 0) {
          this.setNumber = this.setNumber + val;
          if (this.active == true) {
            this.active = false;
          }
        }
      } else if (val < 0) {
        this.setNumber = this.setNumber + val;
        this.trueAnswerCounter = this.trueAnswerCounter - 1;
      } else {
        let answerBilance = this.percentageOf(
          this.trueAnswerCounter,
          quesLength
        );
        
        this.answerBilance = answerBilance;
        this.visible = false;
        this.result = true;
        //this.clearInput();
      }
//      this.clearInput();
    },
  focusInput() {
    this.$refs.quizAnswerRef.$refs.textField.focus();
  },
  log() {
    let setNumber = this.setNumber;
    let answer = this.myQuestions.questions[setNumber].answer;
    let v = this.message;
    if (v == answer) {
      this.trueAnswerCounter = this.trueAnswerCounter + 1;
    }
    this.switch_ques(1);
    this.clearInput();
  },
  contactFormQuery(e){
    let v = e.target.value;
    if(this.screenWidth < 600){
      console.log(v);
    }
    if(v=="J" || v=="j" || v=="y" || v=="Y"){
      this.invitation = false;
      this.result = false;
      this.startForm = true;
    }
    else{
      console.log("beendet");
    }
  },
  percentageOf(n1, n2) {
    let percentage = (n1 * 100) / n2;
    return percentage;
  },
  listAnswers() {
    for (let i = 0; i < this.myQuestions.questions.length; i++) {
      this.answer.push(this.myQuestions.questions[i].answer);
    }
    return this.answer;
  },
  clearInput() {
    this.message = "";
  },
  answerBilanceQuery() {
    let quesLength = this.myQuestions.questions.length;
    let answerBilance = this.percentageOf(this.trueAnswerCounter, quesLength);
    this.answerBilance = answerBilance;
  },
  changeToGoodBye(){
    this.startForm = false;
    this.startGoodbye = true;
  }
  },
};
</script>

<style scoped>
.continueToForm{
  text-align: left;
}
:deep() p {
  font-family: monospace;
  font-size: 1rem;
  text-align: left;
  color: #0f0;
}
p{
  text-align: left;
}
:deep() button {
  font-family: monospace;
  font-size: 1rem;
  width: 75%; /* DEBUG / 50% */
  height: 50%;

}
input {
  cursor: text;
  width: 2rem;
}
:deep() input {
  font-size: 1rem;
  font-family: monospace;

}

@media all and (min-width: 600px) {
  .terminal {
    width: 90%;
    min-width: none;
    height:100%;
    min-height: none;
    background-size: cover;
    background-color:black;
  }
  #terminalFrame {
     height: 100%;
  }
  :deep() p {
    font-size: 1.5rem;
  }

  :deep() button {
    font-size: 1.5rem;
    width: 100%;
    height: 100%;
  }
  :deep() input {
    font-family: monospace;
    font-size: 1.5rem;
  }
  .quiz {
    display: flex;
    flex-direction: column;
    gap: 10px 70px;
  }
}
.terminal {
  font-family: "TerminalFont";
  margin-right: auto;
  margin-left: auto;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
}
.terminalHeader {
  background-color: grey;
  color: black;
  height: 2rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
#windowName{
  margin-left:1%;
  color: black;
}

.windowButton {
  display: flex;
  justify-content: flex-end;
  margin-right:0.5%;
}
#terminalFrame {
  padding-left: 1%;
  padding-right: 1%;
  background-color: black;
  width: 98%;
  margin: auto;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
.quiz {
  display: flex;
  flex-direction: column;
}

.user {
  display: inline-flex;
  text-align: left;
  color: #0f0;
  margin-left: 1 rem;
}
.questionblock {
  display: flex;
  flex-direction: column;
  width: 80%;
  height: 100%;
  top: 20%;
}
.questionButton {
  position: relative;
  left: 0%;
  top: 0%;
  border: 2px solid black;
  width: 100%;
  height: 50%;
  color: #0f0;
  text-align: left;
  background-color: black;
}

button {
  width: 100%;
  height: 100%;
}
.inputBlock {
  display: flex;
  gap: 1rem;
  margin-top: 10rem;
  align-items: center;
}
input {
  background-color: black;
  color: #0f0f;
  border: none;
  outline: none;
}
.quizBar {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}
.results {
  margin: auto;
}
.fieldBody {
  background: #000;
  color: #0f0;
  font-family: monospace;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: scroll;
  margin: 0;
  padding: 16px;
}
#inputField {
  display: inline;
  word-break: break-all;
  outline: none;
  visibility: visible;
  caret-color: transparent;
}
#caret {
  border: 0;
  padding: 0;
  outline: none;
  background-color: #0f0;
  display: inline-block;
  font-family: monospace;
  animation: blink 2s step-end infinite;
}
.mobileButton{
  border:2px solid;
  border-color:#0f0;
  width: 4rem;
}
</style>

